/**
 * Address Module Exports
 * 
 * Main entry point for address autocomplete functionality
 */

import { 
  AddressAutocomplete, 
  initializeAddressAutocomplete, 
  autoInitializeAddressFields,
  type AddressComponents,
  type AddressConfig 
} from './AddressAutocomplete';

export { 
  AddressAutocomplete, 
  initializeAddressAutocomplete, 
  autoInitializeAddressFields,
  type AddressComponents,
  type AddressConfig 
};

// Configuration with provided API key
export const ADDRESS_CONFIG = {
  apiKey: 'AIzaSyB6xZxeIEwdi8-AFSRDb_RleLnqgREqMW8',
  restrictToUS: true,
  delayMs: 300
};

/**
 * Quick initialization function for immediate use
 */
export function initAddressAutocomplete(): void {
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      autoInitializeAddressFields(ADDRESS_CONFIG.apiKey);
    });
  } else {
    autoInitializeAddressFields(ADDRESS_CONFIG.apiKey);
  }
  
  // Also try after delays to catch dynamic content
  setTimeout(() => autoInitializeAddressFields(ADDRESS_CONFIG.apiKey), 1000);
  setTimeout(() => autoInitializeAddressFields(ADDRESS_CONFIG.apiKey), 3000);
}